import { action } from 'typesafe-actions';

import { asyncAction } from 'store/utils/promiseAction';

import { ActionInterface } from 'common/action.interface';
import {
  TransportCardInterface,
  TransportCardSettingsInterface,
  TransportCardsTypes,
} from './types';

// List Transport Cards
export const listTransportCardsRequest = (payload: object) =>
  action(TransportCardsTypes.LIST_TRANSPORT_CARDS_REQUEST, payload);
export const listTransportCardsSuccess = (payload: {
  transportCardsList: TransportCardInterface[];
  transportCardsListFull: TransportCardInterface[];
  isCsvFull?: boolean;
  totalCount: number;
}) => action(TransportCardsTypes.LIST_TRANSPORT_CARDS_SUCCESS, payload);
export const listTransportCardsFailure = () =>
  action(TransportCardsTypes.LIST_TRANSPORT_CARDS_FAILURE);

// Get Transport Card
export const getTransportCardRequest = (payload: object) =>
  action(TransportCardsTypes.GET_TRANSPORT_CARD_REQUEST, payload);
export const getTransportCardSuccess = (payload: {
  transportCardData: TransportCardInterface;
}) => action(TransportCardsTypes.GET_TRANSPORT_CARD_SUCCESS, payload);
export const getTransportCardFailure = () =>
  action(TransportCardsTypes.GET_TRANSPORT_CARD_FAILURE);

// Filter Transport Card
export const filterTransportCardsRequest = (payload: object) =>
  asyncAction(TransportCardsTypes.FILTER_TRANSPORT_CARD_REQUEST, payload);

export const filterTransportCardsSuccess = (payload: {
  transportCardsList: TransportCardInterface[];
  totalCount: number;
}) => action(TransportCardsTypes.FILTER_TRANSPORT_CARD_SUCCESS, payload);

export const filterTransportCardsFailure = () =>
  action(TransportCardsTypes.FILTER_TRANSPORT_CARD_FAILURE);

// Get Transport Card From Number
export const getTransportCardFromNumberRequest = (payload: object) =>
  action(TransportCardsTypes.GET_TRANSPORT_CARD_FROM_NUMBER_REQUEST, payload);
export const getTransportCardFromNumberSuccess = (payload: {
  transportCardData: TransportCardInterface;
}) =>
  action(TransportCardsTypes.GET_TRANSPORT_CARD_FROM_NUMBER_SUCCESS, payload);
export const getTransportCardFromNumberFailure = () =>
  action(TransportCardsTypes.GET_TRANSPORT_CARD_FROM_NUMBER_FAILURE);

// Create Transport Card
export const createTransportCardRequest = (payload: {
  userId?: string;
  body: object;
}) => asyncAction(TransportCardsTypes.CREATE_TRANSPORT_CARD_REQUEST, payload);
export const createTransportCardSuccess = (payload: {
  transportCardData: TransportCardInterface;
}) => action(TransportCardsTypes.CREATE_TRANSPORT_CARD_SUCCESS, payload);
export const createTransportCardFailure = () =>
  action(TransportCardsTypes.CREATE_TRANSPORT_CARD_FAILURE);

// Create Transport Cards
export const createTransportCardsRequest = (payload: object) =>
  action(TransportCardsTypes.CREATE_TRANSPORT_CARDS_REQUEST, payload);
export const createTransportCardsSuccess = () =>
  action(TransportCardsTypes.CREATE_TRANSPORT_CARDS_SUCCESS);
export const createTransportCardsFailure = () =>
  action(TransportCardsTypes.CREATE_TRANSPORT_CARDS_FAILURE);

// Active Transport Cards
export const activeDeviceRequest = (payload: object) =>
  action(TransportCardsTypes.ACTIVE_DEVICE_REQUEST, payload);
export const activeDeviceSuccess = () =>
  action(TransportCardsTypes.ACTIVE_DEVICE_SUCCESS);
export const activeDeviceFailure = () =>
  action(TransportCardsTypes.ACTIVE_DEVICE_FAILURE);

// Update Transport Card
export const updateTransportCardRequest = (payload: object) =>
  action(TransportCardsTypes.UPDATE_TRANSPORT_CARD_REQUEST, payload);
export const updateTransportCardSuccess = () =>
  action(TransportCardsTypes.UPDATE_TRANSPORT_CARD_SUCCESS);
export const updateTransportCardFailure = () =>
  action(TransportCardsTypes.UPDATE_TRANSPORT_CARD_FAILURE);

// Update Transport Card Status
export const updateTransportCardStatusRequest = (payload: object) =>
  action(TransportCardsTypes.UPDATE_TRANSPORT_CARD_STATUS_REQUEST, payload);
export const updateTransportCardStatusSuccess = () =>
  action(TransportCardsTypes.UPDATE_TRANSPORT_CARD_STATUS_SUCCESS);
export const updateTransportCardStatusFailure = () =>
  action(TransportCardsTypes.UPDATE_TRANSPORT_CARD_STATUS_FAILURE);

// Delete Transport Card
export const deleteTransportCardRequest = (payload: object) =>
  action(TransportCardsTypes.DELETE_TRANSPORT_CARD_REQUEST, payload);
export const deleteTransportCardSuccess = () =>
  action(TransportCardsTypes.DELETE_TRANSPORT_CARD_SUCCESS);
export const deleteTransportCardFailure = () =>
  action(TransportCardsTypes.DELETE_TRANSPORT_CARD_FAILURE);

// Request Transport Card
export const requestTransportCardRequest = (payload: object) =>
  action(TransportCardsTypes.REQUEST_TRANSPORT_CARD_REQUEST, payload);
export const requestTransportCardSuccess = () =>
  action(TransportCardsTypes.REQUEST_TRANSPORT_CARD_SUCCESS);
export const requestTransportCardFailure = () =>
  action(TransportCardsTypes.REQUEST_TRANSPORT_CARD_FAILURE);

// Activate Transport Card
export const activateTransportCardRequest = (payload: object) =>
  action(TransportCardsTypes.ACTIVATE_TRANSPORT_CARD_REQUEST, payload);
export const activateTransportCardSuccess = () =>
  action(TransportCardsTypes.ACTIVATE_TRANSPORT_CARD_SUCCESS);
export const activateTransportCardFailure = () =>
  action(TransportCardsTypes.ACTIVATE_TRANSPORT_CARD_FAILURE);

// Assign Transport Card
export const assignTransportCardRequest = (
  payload: object,
  dispatchOnSuccess?: ActionInterface,
) =>
  action(TransportCardsTypes.ASSIGN_TRANSPORT_CARD_REQUEST, payload, {
    dispatchOnSuccess,
  });
export const assignTransportCardSuccess = () =>
  action(TransportCardsTypes.ASSIGN_TRANSPORT_CARD_SUCCESS);
export const assignTransportCardFailure = () =>
  action(TransportCardsTypes.ASSIGN_TRANSPORT_CARD_FAILURE);

// Unassign Transport Card
export const unassignTransportCardRequest = (
  payload: object,
  dispatchOnSuccess?: ActionInterface,
) =>
  action(TransportCardsTypes.UNASSIGN_TRANSPORT_CARD_REQUEST, payload, {
    dispatchOnSuccess,
  });
export const unassignTransportCardSuccess = () =>
  action(TransportCardsTypes.UNASSIGN_TRANSPORT_CARD_SUCCESS);
export const unassignTransportCardFailure = () =>
  action(TransportCardsTypes.UNASSIGN_TRANSPORT_CARD_FAILURE);

// transport CardSettings Update
export const updateTransportCardSettingsRequest = (payload: object) =>
  action(TransportCardsTypes.UPDATE_TRANSPORT_CARD_SETTINGS_REQUEST, payload);
export const updateTransportCardSettingsSuccess = () =>
  action(TransportCardsTypes.UPDATE_TRANSPORT_CARD_SETTINGS_SUCCESS);
export const updateTransportCardSettingsFailure = () =>
  action(TransportCardsTypes.UPDATE_TRANSPORT_CARD_SETTINGS_FAILURE);

// Get TransportCard Settings
export const getTransportCardSettingsRequest = (payload: object) =>
  action(TransportCardsTypes.GET_TRANSPORT_CARD_SETTINGS_REQUEST, payload);
export const getTransportCardSettingsSuccess = (payload: {
  transportCardSettings: TransportCardSettingsInterface;
}) => action(TransportCardsTypes.GET_TRANSPORT_CARD_SETTINGS_SUCCESS, payload);
export const getTransportCardSettingsFailure = () =>
  action(TransportCardsTypes.GET_TRANSPORT_CARD_SETTINGS_FAILURE);
